import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { BuildNumberService } from "../services/build-number.service";

@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class FooterComponent implements OnInit {

    buildNumber: string;

    private conf: any;

    get governor(): string {
        if (this.conf == null) return "";
        return this.conf.governor;
    }

    get director(): string {
        if (this.conf == null) return "";
        return this.conf.director;
    }

    get address(): string {
        if (this.conf == null) return "";
        return this.conf.address;
    }

    get city(): string {
        if (this.conf == null) return "";
        return this.conf.city;
    }

    get zipCode(): string {
        if (this.conf == null) return "";
        return this.conf.zipCode;
    }

    get phone(): string {
        if (this.conf == null) return "";
        return this.conf.phone;
    }

    get phoneHref(): string {
        return `tel:${this.phone}`;
    }

    get phoneFormatted(): string {
        if (this.phone.length != 10) return this.phone;
        let area = this.phone.slice(0, 3);
        let prefix = this.phone.slice(3, 6);
        let suffix = this.phone.slice(6, 10);
        return `(${area}) ${prefix}-${suffix}`;
    }
        
    constructor(public buildNumberService: BuildNumberService) {
    }

    ngOnInit(): void {
        this.buildNumber = this.buildNumberService.displayValue;

        this.conf = window["footerConfig"] as any;
    }

}